import { render, staticRenderFns } from "./BottomBanner.vue?vue&type=template&id=b1f6f284&scoped=true"
import script from "./BottomBanner.vue?vue&type=script&lang=js"
export * from "./BottomBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f6f284",
  null
  
)

export default component.exports